import { render } from "./Crud.vue?vue&type=template&id=7b30cc5e&scoped=true"
import script from "./Crud.vue?vue&type=script&lang=js"
export * from "./Crud.vue?vue&type=script&lang=js"

import "./Crud.vue?vue&type=style&index=0&id=7b30cc5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b30cc5e"]])

export default __exports__